import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const PreQualifyFinancingMockAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "pre-qualify-financing-mock" */ './pre-qualify-financing-mock'),
  componentName: 'PreQualifyFinancingMock',
});
